import { useEffect, useState } from "react";
import { EnvelopeOpen, Clock } from "@phosphor-icons/react";
import client from "../lib/api";

const fmtHour = (h) => (h === 0 ? "12am" : h < 12 ? `${h}am` : h === 12 ? "12pm" : `${h - 12}pm`);

export const PlaybookNudgeCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/admin/playbook-nudge/stats").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.nudges_sent) return null;

  return (
    <div className="mt-6 card-surface p-4" data-testid="playbook-nudge-card">
      <div className="flex items-center gap-2 mb-3">
        <EnvelopeOpen size={14} weight="bold" color="#34d399" />
        <span className="overline">PLAYBOOK NUDGES · DO THE EMAILS WORK?</span>
        <span className="ml-auto text-[10px] font-mono text-neutral-400" data-testid="playbook-nudge-summary">
          {data.converted}/{data.nudges_sent} converted · {data.rate_pct}%
        </span>
      </div>
      <div className="space-y-2">
        {data.by_step.slice(0, 6).map((r) => (
          <div key={r.key} data-testid={`playbook-nudge-row-${r.key}`} className="flex items-center gap-3">
            <span className="text-[11px] text-neutral-300 w-40 shrink-0 truncate">{r.label}</span>
            <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden">
              <div
                className={`h-full rounded-full ${r.rate >= 50 ? "bg-emerald-400" : r.rate >= 20 ? "bg-amber-400" : "bg-white/20"}`}
                style={{ width: `${Math.max(2, r.rate)}%` }}
              />
            </div>
            <span className="text-[10px] font-mono text-neutral-400 w-24 text-right shrink-0">
              {r.converted}/{r.sent} · <span className={r.rate >= 50 ? "text-emerald-300" : "text-neutral-300"}>{r.rate}%</span>
            </span>
          </div>
        ))}
      </div>
      <div className="text-[10px] text-neutral-500 mt-3">
        "Converted" = the nudged step got completed after the email landed.
      </div>
      {data.hour_ab && (
        <div className="mt-3 flex items-start gap-2 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2"
             data-testid="playbook-nudge-hour-ab">
          <Clock size={13} weight="bold" className="mt-0.5 shrink-0 text-[#FF9764]" />
          {data.hour_ab.status === "decided" ? (
            <span className="text-[11px] text-emerald-300 font-bold">
              Winning hour locked: {fmtHour(data.hour_ab.winner === "A" ? data.hour_ab.hour_a : data.hour_ab.hour_b)} CT
              <span className="text-neutral-400 font-normal">
                {" "}— all nudges now send then ({data.hour_ab.a.rate}% vs {data.hour_ab.b.rate}%)
              </span>
            </span>
          ) : (
            <span className="text-[11px] text-neutral-300">
              <b>Hour test:</b> {fmtHour(data.hour_ab.hour_a)} CT {data.hour_ab.a.rate}% ({data.hour_ab.a.converted}/{data.hour_ab.a.sent})
              {" vs "}{fmtHour(data.hour_ab.hour_b)} CT {data.hour_ab.b.rate}% ({data.hour_ab.b.converted}/{data.hour_ab.b.sent})
              <span className="text-neutral-500"> · winner locks at {data.hour_ab.min_sample} sends each</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};
